import { configureStore } from "@reduxjs/toolkit";
import loggedOnUser from "./loggedOnUser";
import serverAppConfig from './ServerAppConfig';
import appConfig from "./appConfig";
import { useDispatch, useSelector } from 'react-redux'
import cmdbUsers from './cmdbUsers';
import cmdbUsersId from './cmdbUsersId';
import wells from "./wells";

export const store = configureStore({
    reducer: {
        loggedOnUser: loggedOnUser,
        cmdbUsers: cmdbUsers,    
        cmdbUsersId: cmdbUsersId,
        wells: wells,
        appConfig: appConfig,
        serverAppConfig: serverAppConfig,
    },
})

type RootState = ReturnType<typeof store.getState>
type AppDispatch = typeof store.dispatch

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()